import { createStyles, Theme } from '@material-ui/core/styles';

const styles = ({ colors, spacing }: Theme) => createStyles({
  icon: {
    height: spacing(4),
    '& svg': {
      fill: colors.uIIconBase,
    },
  },
});

export default styles;
